import React from "react";
import PageHeader from "@/components/PageHeader";
import PricingEditor from "@/components/PricingEditor";
import { Card } from "@/components/ui/card";

export default function PricingSettings() {
  return (
    <div>
      <PageHeader
        eyebrow="Package Management"
        title="Package Pricing & Settings"
        subtitle="Add, edit, or remove Umrah packages, room types, add-ons, and visa fees"
        image="https://images.unsplash.com/photo-1720549973451-018d3623b55a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxtdXNsaW0lMjBwaWxncmltYWdlJTIwbWVjY2F8ZW58MHx8fHwxNzkwMzQ4MDMzfDA&ixlib=rb-4.1.0&q=85"
      />
      <div className="p-4 sm:p-8 max-w-4xl">
        <Card className="p-6 bg-card/40 border-gold/30">
          <PricingEditor />
        </Card>
      </div>
    </div>
  );
}
